import {GetterTree} from "vuex";
import {QuantityLimitState} from "@/store/settings/quantity_limits/types";
import {RootState} from "@/store/types";

export const getters: GetterTree<QuantityLimitState, RootState> = {
    quantityLimits:state => state.quantityLimit,
    quantityLimitItem:state => state.quantityLimitItem
}
